import React from 'react'
import { H1, RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsWhyShouldYouInvestType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSWhyShouldYouInvest = ({
  whyShouldYouInvest,
}: {
  whyShouldYouInvest?: CMSOpportunityDetailsWhyShouldYouInvestType
}) => {
  return (
    <section className='investment-reason' data-testid='cms-why-should-you-invest-content'>
      {whyShouldYouInvest?.reasons?.map((reason, idx) => (
        <section
          className={`flex ${reason.imagePosition === 'left' ? 'flex-row-reverse' : ''} ${
            idx > 0 ? 'opportunity-cms-section-spaced-block' : ''
          }`}
          data-testid={`cms-why-should-you-invest-reason-${idx}`}
          key={idx}
        >
          <section className='flex-item-2col'>
            <H1
              text={reason.primaryText}
              classes={['headings-blue-charlie', 'headings-size-28px']}
            />
            {reason.blockText?.length && (
              <CmsSectionText className='mt-24px'>
                <RichTextRenderer content={reason.blockText} variant='opportunity-details' />
              </CmsSectionText>
            )}
          </section>
          <section className='flex-item-2col investment-reason-img'>
            <img src={reason.image} alt={`Why should you invest image ${idx + 1}`} />
          </section>
        </section>
      ))}
    </section>
  )
}

export { CMSWhyShouldYouInvest }
